"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicTableToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * The BasicTableToolbar is generic toolbar for DataTable providing a text search and a "enabled" switch. The caller must pass in props:
 *  a function called "tableHasSelectedRows" which is true when a row is selected
 *  a function called "onSearchChange" when the search field text, which accepts a search string (product search)
 *  a function called "onEnabledSwitchChanged" when the enabled switch changes state
 *  a function called "foundRecords" which is called whenever the search field text changes to see if the search text field should go red (nothing found)
 *  a string called "searchTooltip" which is a string used in the search field tooltip
 *  a string called "enabledTooltip" which is a string used in the enabled switch tooltip
 *  a boolean "hideEnabledSwitch" which if present and true hides the enabled switch (default false)
 */
var BasicTableToolbar = exports.BasicTableToolbar = /*#__PURE__*/function (_Component) {
  function BasicTableToolbar(props) {
    var _this;
    _classCallCheck(this, BasicTableToolbar);
    _this = _callSuper(this, BasicTableToolbar, [props]);
    _defineProperty(_this, "styles", {
      textfield: {
        marginBottom: 10,
        marginLeft: 10
      },
      switchLabel: {
        fontSize: 12
      },
      formLabel: {},
      iconButton: {
        marginTop: 8,
        marginRight: 5,
        marginLeft: 5
      }
    });
    _defineProperty(_this, "state", {
      searchString: "",
      showEnabled: false
    });
    _defineProperty(_this, "_searchChangedCallback", void 0);
    _defineProperty(_this, "_showEnabledFilterCallback", void 0);
    _defineProperty(_this, "_foundRecords", void 0);
    _defineProperty(_this, "_rowsAreSelected", void 0);
    _defineProperty(_this, "_searchTooltip", void 0);
    _defineProperty(_this, "_enabledTooltip", void 0);
    _defineProperty(_this, "_hideEnabled", false);
    //Reset toolbar search and enabled settings
    _defineProperty(_this, "reset", function () {
      _this.setState({
        searchString: "",
        showEnabled: false
      });
    });
    _defineProperty(_this, "_searchFieldChanged", function (event) {
      var searchString = event.target.value;
      _this.setState({
        searchString: searchString
      });
      _this._searchChangedCallback(searchString);
    });
    _defineProperty(_this, "_toggleEnabled", function (event) {
      _this._showEnabledFilterCallback(!_this.state.showEnabled);
      _this.setState(function (prevState) {
        return {
          showEnabled: !prevState.showEnabled
        };
      });
    });
    _this._searchChangedCallback = props.onSearchChange;
    _this._showEnabledFilterCallback = props.onEnabledSwitchChanged;
    _this._foundRecords = props.foundRecords;
    _this._rowsAreSelected = props.tableHasSelectedRows;
    _this._searchTooltip = props.searchTooltip;
    _this._enabledTooltip = props.enabledTooltip;
    _this._hideEnabled = props.hideEnabledSwitch;
    return _this;
  }
  _inherits(BasicTableToolbar, _Component);
  return _createClass(BasicTableToolbar, [{
    key: "render",
    value: function render() {
      var filterColor = this._foundRecords() ? 'primary' : 'secondary';
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: this._searchTooltip
      }, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
        label: "Search",
        type: "search",
        value: this.state.searchString,
        onChange: this._searchFieldChanged,
        color: filterColor,
        margin: "dense",
        style: this.styles.textfield,
        InputLabelProps: {
          shrink: true
        }
      })), this._hideEnabled ? null : /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: this._enabledTooltip
      }, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        style: this.styles.formLabel,
        control: /*#__PURE__*/_react["default"].createElement(_core.Switch, {
          size: "small",
          color: "primary",
          checked: this.state.showEnabled,
          onChange: this._toggleEnabled
        }),
        labelPlacement: "top",
        label: /*#__PURE__*/_react["default"].createElement(_core.Typography, {
          variant: "body2",
          style: this.styles.switchLabel,
          color: "textSecondary"
        }, "Enabled")
      })));
    }
  }]);
}(_react.Component);